<template>
  <PCHeaderBar />

  <div class="pc__home">
    <ClientOnly>
      <div class="home-bg">
        <img :src="$cvWebpFn(homeBgImage.imageUrl)" alt="" v-if="homeBgImage">
      </div>
    </ClientOnly>
    
    <div class="pc__inner-home">
      <!-- -start- 首页前  1.5 屏 -start- -->
      <div class="header-wrapper">
        <div class="category-select-box">
          <PCCategorySelect />
        </div>

        <div class="banner-list">
          <div class="tabs">
            <div class="tab" @click="router.push('/new-arrival?first_page=home')">What's New</div>
            <div class="tab" @click="router.push('/flash-sales?source=homePage|flashSale|')">Flash Sale</div>
          </div>
          <div class="banners">
            <PCHomeBanner :banners="banners || []" />
          </div>
        </div>
      </div>

      <div class="small-banners">
        <div
          v-for="(val, i) in smallBanners"
          :key="i"
          class="img-box"
        >
          <a
            :href="handleSmallBannerHref(val)"
            target="_blank"
            @click="handleSmallBannerNavigate(val, $event)"
          >
            <img :src="$cvWebpFn(val.imageUrl, { w: 560 })" loading="lazy" class="small-image" >
          </a>
        </div>
      </div>

      <div class="home-card flash-sale" v-if="showFlashSale">
        <PCFlashSaleBar @no-data="showFlashSale = false" />
      </div>

      <div v-if="categoryList && categoryList.length" class="home-card">
        <PCHotCategory :categoryList="categoryList.slice(0, 20)" />
      </div>
      <!-- -end- 首页前  1.5 屏 -end- -->

      <ClientOnly>
        <div class="home-card whats-new" v-if="newArrivalShow">
          <KViewportMount><PCWhatsNewVue @hidden="newArrivalShow = false" /></KViewportMount>
        </div>

        <div class="home-card">
          <KViewportMount><LazyPCYouMayLike :recommend-id="1" /></KViewportMount>
        </div>

        <template #fallback>
          <div class="home-card client-component-loading">
            <van-loading size="40px" color="#DD3131" type="spinner" />
          </div>
        </template>
      </ClientOnly>
    </div>
  </div>

  <ClientOnly>
    <div style="background-color: #f7f7f7;" class="home-card mod_agree">
      <ul class="mod_agree_con">
        <li class="mod_agree_item mod_agree_item1">
          <a class="mod_circle mb-3"><img class="lazyload" v-lazy="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/great-value@2x.png', { w: 200 })"></a>
          <p class="f_title"><strong>Great Value</strong></p>
          <p><span class="mt-1">We offer competitive prices on our 10 million plus product range.</span></p>
        </li>
        <li class="mod_agree_item mod_agree_item2">
          <a class="mod_circle mb-3"><img class="lazyload" v-lazy="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/world-wide-delivery@2x.png', { w: 200 })"></a>
          <p class="f_title"><strong>Worldwide Delivery</strong></p>
          <p><span class="mt-1">With sites in 3 languages, we ship to over 20 countries &amp; regions.</span></p>
        </li>
        
        <li class="mod_agree_item mod_agree_item4">
          <a class="mod_circle mb-3"><img class="lazyload" v-lazy="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/safe-payment@2x.png', { w: 200 })"></a>
          <p class="f_title"><strong mb-3>Safe Payment</strong></p>
          <p><span class="mt-1">Pay with the world’s most popular and secure payment methods.</span></p>
        </li>

        <li class="mod_agree_item mod_agree_item4">
          <a class="mod_circle mb-3"><img class="lazyload" v-lazy="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/shop-with-confidence@2x.png', { w: 200 })"></a>
          <p class="f_title"><strong mb-3>Shop with Confidence</strong></p>
          <p><span class="mt-1">Our Buyer Protection covers your purchase from click to delivery.</span></p>
        </li>
        <li class="mod_agree_item mod_agree_item5">
          <a class="mod_circle mb-3"><img class="lazyload" v-lazy="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/help-center@2x.png', { w: 200 })" style="display: inline;"></a>
          <p class="f_title"><strong>24/7 Help Center</strong></p>
          <p><span class="mt-1">Round-the-clock assistance for a smooth shopping experience.</span></p>
        </li>
        <li class="mod_agree_item mod_agree_item6">
          <a class="mod_circle mb-3"><img class="lazyload" v-lazy="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/shop-on-the-go@2x.png', { w: 200 })" style="display: inline;"></a>
          <p class="f_title"><strong>Shop On-The-Go</strong></p>
          <p><span class="mt-1">Download the app and get the world of Kilimall at your fingertips.</span></p>
        </li>
      </ul>
    </div>
  </ClientOnly>

  <div style="background-color: #f7f7f7;">
    <div class="seo-text">
      <h1>
        Kilimall - Online Shopping in {{ regionId === '8' ? 'Uganda' : 'Kenya' }}
      </h1>
      <p>
        Kilimall is {{ regionId === '8' ? 'Uganda' : 'Kenya' }}'s leading online shopping mall. It was launched in June 2014 with the mission of  "Enriching Lives for Africa".
      </p>
      <p>
        Kilimall serves a retail-customer base that continues to grow exponentially, offering products that span various categories including Electronics such as <a href="/search?q=smart+phone" target="_blank"><strong>smart phones</strong></a>, <a href="/search?q=laptops" target="_blank"><strong>laptops</strong></a>, <a href="/search?q=subwoofer" target="_blank"><strong>subwoofer</strong></a>&nbsp;etc, <a href="/search?q=Clothing" target="_blank"><strong>Clothing</strong></a>, <a href="/search?q=Home+Appliances" target="_blank"><strong>Home Appliances</strong></a>, <a href="/search?q=Fashion+bag" target="_blank"><strong>Fashion bag</strong></a>,&nbsp;<a href="/search?q=Baby" target="_blank"><strong>Baby </strong>Products</a>, <a href="/search?q=makeup" target="_blank"><strong>makeup</strong></a> and much more. Kilimall continues to expand the mall, with the scope of offerings that will increase in variety, simplicity and convenience.
      </p>
      <p>
        The range of services are designed to ensure optimum levels of convenience and customer satisfaction with the retail process; order delivery-tracking, dedicated customer service support and many other premium services. The company is highly customer-centric and are committed towards finding innovative ways of improving the customers' shopping experience.
      </p>
      <p>
        Now, shopping with Kilimall App will bring you millions of cash rewards, best customer services, and track your order at anytime. Download&nbsp;<a href="https://play.google.com/store/apps/details?id=net.kilimall.shop"><strong>Kilimall App APK</strong></a>&nbsp;and enjoy best service online in {{ regionId === '8' ? 'Uganda' : 'Kenya' }}.
      </p>
    </div>
    <div class="why-choose-section">
      <h2 class="section-title">Why Choose Kilimall?</h2>
      <div class="feature-list">
        <div class="feature-item">
          <span class="check-icon">✓</span>
          <div class="feature-content">
            <strong>Trustworthy Reviews:</strong> Read thousands of verified customer reviews to make informed purchase decisions.
          </div>
        </div>
        <div class="feature-item">
          <span class="check-icon">✓</span>
          <div class="feature-content">
            <strong>Secure Payments:</strong> Use secure local payment methods like Mpesa, Airtel Money, EcoBank, Visa, MasterCard, and more.
          </div>
        </div>
        <div class="feature-item">
          <span class="check-icon">✓</span>
          <div class="feature-content">
            <strong>Parcel Tracking:</strong> Track your orders step-by-step from picking to delivery, ensuring full control and peace of mind.
          </div>
        </div>
        <div class="feature-item">
          <span class="check-icon">✓</span>
          <div class="feature-content">
            <strong>Trusted Sellers:</strong> Shop from certified sellers offering over 1 million products across all categories.
          </div>
        </div>
        <div class="feature-item">
          <span class="check-icon">✓</span>
          <div class="feature-content">
            <strong>Great Discounts:</strong> Enjoy significant discounts on high-quality products at affordable prices.
          </div>
        </div>
        <div class="feature-item">
          <span class="check-icon">✓</span>
          <div class="feature-content">
            <strong>Big Brands:</strong> APPLE, SAMSUNG, SONY, HISENSE, TCL, HAIER, VITRON, VON, VIVO, XIAOMI, LENOVO, LG, OPPO, TECNO, INFINIX, L'OREAL, and more.
          </div>
        </div>
        <div class="feature-item">
          <span class="check-icon">✓</span>
          <div class="feature-content">
            <strong>Rewards Program:</strong> Earn daily coins through sign-ins, registrations, orders, reviews, and referrals for additional savings.
          </div>
        </div>
        <div class="feature-item">
          <span class="check-icon">✓</span>
          <div class="feature-content">
            <strong>New User Offers:</strong> Get unbeatable deals and redeem free cash vouchers worth over KSh 100.
          </div>
        </div>
      </div>

      <h2 class="section-title">Shop Smart Across 10M+ Products:</h2>
      <div class="category-list">
        <div class="category-item">
          <span class="category-icon">📺</span>
          <div class="category-content">
            <strong>Major Home Appliances:</strong> TVs, Refrigerators and Freezers, Washing Machines, Audio Systems, Integrated Stoves, Solar Products, etc.
          </div>
        </div>
        <div class="category-item">
          <span class="category-icon">📻</span>
          <div class="category-content">
            <strong>Small Home Appliances:</strong> Kitchen Appliances(Electric Kettles, Water Dispensers, Juicers, Gas Stoves, etc.), Other Appliances(Irons, Robotic Vacuum Cleaners, etc.)
          </div>
        </div>
        <div class="category-item">
          <span class="category-icon">📱</span>
          <div class="category-content">
            <strong>Mobile Phones & Accessories:</strong> Mobile Phones, Headphones, Memory Cards, Power Banks, Live Streaming Equipment, Smart Watches, etc.
          </div>
        </div>
        <div class="category-item">
          <span class="category-icon">🛌</span>
          <div class="category-content">
            <strong>Home & Kitchen:</strong> Kitchenware(Pots and Sets, Tableware, Drinkware, Small Tools, etc.), Storage Solutions(Wardrobes, Shoe Racks, Bedding, Furniture, Home Decor, etc.)
          </div>
        </div>
        <div class="category-item">
          <span class="category-icon">❤</span>
          <div class="category-content">
            <strong>Beauty & Personal Care:</strong> Skincare Products, Makeup, Wigs, Health Care Items, etc.
          </div>
        </div>
        <div class="category-item">
          <span class="category-icon">💃</span>
          <div class="category-content">
            <strong>Fashion for Everyone:</strong> Men's, Women's, Kids', and Baby Clothing, Shoes, Bags, Watches, Jewelry, etc.
          </div>
        </div>
        <div class="category-item">
          <span class="category-icon">💻</span>
          <div class="category-content">
            <strong>Computers & Accessories:</strong> Laptops, Tablets, Computer Accessories(Mice, Keyboards, Power Cables, etc.)
          </div>
        </div>
        <div class="category-item">
          <span class="category-icon">🎾</span>
          <div class="category-content">
            <strong>Other Categories:</strong> Sports & Outdoor Goods, Baby & Maternity Products, Toys, Automotive Accessories, Office Supplies & Industrial Products, etc.
          </div>
        </div>
      </div>
    </div>
  </div>

  <LazyPCFooter />

  <LazyKCookiePopup />
</template>

<script setup lang="ts">
import PCCategorySelect from './pc-widgets/CategorySelect.vue'
import PCHomeBanner from './pc-widgets/HomeBanner.vue'
import PCFlashSaleBar from './pc-widgets/FlashSaleBar.vue'
import PCHotCategory from './pc-widgets/HotCategory.vue'
const PCWhatsNewVue = defineAsyncComponent(() => import('./pc-widgets/WhatsNew.vue'))
import { setWebSite } from './home.website'
import { buildHomeBannerSource, filterBanners, buildBannerIdNameSourceValue } from '~/plugins/utils'

definePageMeta({ layout: 'wap' })
setWebSite()
const newArrivalShow = ref<boolean>(true)
const showFlashSale = ref(!!useGlobalJsonData().value.flashsale?.data?.skus?.length)
const { $tz, $getHotKeysJumpUrl } = useNuxtApp()
const router = useRouter()

const homeBgImage = ref<IBanner>()
const banners = ref<IBanner[]>([])
const smallBanners = ref<IBanner[]>([])
const categoryList = ref<ICategory[]>([])
const bgColor = ref('')
const regionId = useCurrentCountry().value ? useCurrentCountry().value.toString() : '6'

const mounted = async() => {
  const { banner_app_v2, hot_categories } = useGlobalJsonData().value
  const { homeBanner, smallBanner, bgBanner } = banner_app_v2.data

  banners.value = filterBanners(homeBanner)
  console.log('banners', banners.value)
  smallBanners.value = filterBanners(smallBanner)
  categoryList.value = hot_categories.data || []

  if(process.client) {
    const bgImgs = filterBanners(bgBanner)
    bgImgs.length > 0 && (homeBgImage.value = bgImgs[0])
    if (homeBgImage && homeBgImage.value && homeBgImage.value.startColor && homeBgImage.value.endColor) {
      bgColor.value = `linear-gradient(to bottom right, ${homeBgImage.value.startColor}, ${homeBgImage.value.endColor})`
    } else if (homeBgImage && homeBgImage.value && (homeBgImage.value.startColor || homeBgImage.value.endColor)) {
      bgColor.value = `${homeBgImage.value.startColor || homeBgImage.value.endColor}`
    }

    const pcHomeEl: HTMLElement | any = document.querySelector('.pc__home')
    if (pcHomeEl) {
      pcHomeEl.style.background = bgColor.value
    } else if(bgColor.value){
      // 路由切换至首页存在元素延迟的情况
      const setBgColor = () => {
        setTimeout(() => {
            document.querySelector('.pc__home').style.background = bgColor.value
            if (!document.querySelector('.pc__home')) {
              setBgColor()
            }
        }, 150)
      }
      setBgColor()
    }

  }
  // homeBgImage.value = {
  //   imageUrl: 'https://img.kilimall.com/c/public/banner-image/100004638.jpg?x-image-process=image/format,webp#'
  // }
}
mounted()
const getSmallBannerJump = (item: IBanner, writeCache = false) => {
  if (!item) {
    return { href: '' as string, cacheWrite: undefined as Promise<void> | undefined }
  }
  const source = buildHomeBannerSource(
    'homeNavBottomSmallBanner',
    buildBannerIdNameSourceValue(item),
    item.configType
  )
  return $getHotKeysJumpUrl(
    { linkType: item.configType, linkValue: item.value },
    true,
    source,
    { writeCache }
  )
}

/** 模板绑 :href：只生成链接，不写 url-cache（避免重渲染刷 set-params） */
const handleSmallBannerHref = (item: IBanner): string => getSmallBannerJump(item, false).href || ''

/** listing/sku：点击时再写 cache */
const handleSmallBannerNavigate = async (item: IBanner, e: MouseEvent) => {
  if (![5, 10].includes(Number(item?.configType))) return
  e.preventDefault()
  // Safari：必须在 await 之前同步 open，否则会提示弹出式窗口被阻止
  const popup = window.open('about:blank', '_blank')
  const res = getSmallBannerJump(item, true)
  if (res.cacheWrite) {
    await res.cacheWrite.catch(() => {})
  }
  if (!res.href) {
    popup?.close()
    return
  }
  if (popup && !popup.closed) {
    popup.location.replace(res.href)
  } else {
    window.location.href = res.href
  }
}
</script>

<style lang="scss" scoped>
.client-component-loading{
  text-align: center;
}
.pc__header-box{
  padding-bottom: 70px;
}

.pc__home{
  position: relative;
  .pc__inner-home{
    width: var(--viewport-width);
    margin: 0 auto;
    position: relative;
    z-index: 9;
  }
  .home-bg{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    text-align: center;
    line-height: 0;
    img{
      // width: 100%;
      width: 3760px;
    }
  }
  // @media (max-width: 1800px) { 
  //   .pc__inner-home{
  //     width: 1880px;
  //   }
  //   .home-bg {
  //     img {
  //       width: 2900px;
  //     }
  //   }
  // }
}
.home-card{
  margin-top: 40px;
  background-color: #fff;
  padding: 40px;
}
.header-wrapper{
  background-color: #fff;
  display: flex;
  min-height: 944px;
  // overflow: hidden;
  .category-select-box{
    min-width: 500px;
    position: relative;
    height: 944px;
    z-index: 99;
    margin-top: -80px;
  }
  .banner-list{
    flex: 1;
    margin-top: -80px;
    overflow: hidden;
    .banners{
      height: 944px;
      width: 100%;
    }
    .tabs{
      height: 80px;
      line-height: 80px;
      display: flex;
      .tab{
        width: 360px;
        text-align: center;
        background-color: #fff;
        cursor: pointer;
        transition: all .15s;
        font-size: 32px;
        font-weight: 600;
        // text-shadow: 0 0 2px #333;
        &:hover{
          color: var(--pc-default-color);
        }
      }
    }
  }
}
.small-banners{
  margin: 40px -10px;
  display: flex;
  flex-wrap: nowrap;
  height: 400px;
  overflow: hidden;
  .img-box{
    width: 25%;
    padding: 10px;
    max-height: 400px;
    overflow: hidden;
    img{
      cursor: pointer;
      width: 100%;
      object-fit: contain;
    }
  }
}
// @media (max-width: 1800px) { 
//   .header-wrapper {
//     min-height: 688px;
//   }
//   .header-wrapper .category-select-box {
//     height: 688px;
//   }
//   .header-wrapper .banner-list .banners {
//     height: 688px;
//   }
//   .small-banners {
//     height: 300px;
//   }
// }

.mod_agree_con{
  width: var(--viewport-width);
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 30px 0;
  .mod_agree_item{
    text-align: center;
    .f_title{
      margin: 20px 0;
    }
    .mt-1{
      color: #999;
      line-height: 34px;
    }
    .mod_circle{
      height: 145px;
      width: 145px;
      display: inline-block;
      padding: 30px;
      // margin-bottom: 40px;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
.seo-text{
  width: var(--viewport-width);
  border-top: 1px solid #D9D9D9;
  margin: 0 auto;
  padding: 80px 0 0 0;
  
  h1{
    margin-bottom: 60px;
    font-size: 42px;
    font-weight: 600;
  }
  p{
    margin-top: 30px;
    line-height: 36px;
  }
}

.why-choose-section {
  width: var(--viewport-width);
  margin: 0 auto;
  padding: 0 0 80px 0;
  color: #333;
}

.section-title {
  font-size: 36px;
  font-weight: 600;
  margin: 60px 0 40px;
  color: #333;
}

.feature-list, .category-list {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.feature-item, .category-item {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  line-height: 1.5;
}

.check-icon {
  color: #6563ff;
  font-size: 24px;
  font-weight: bold;
  min-width: 24px;
}

.category-icon {
  font-size: 24px;
  min-width: 30px;
}

.feature-content, .category-content {
  flex: 1;
  font-size: 28px;
}

.feature-content strong, .category-content strong {
  color: #333;
  font-weight: 600;
}
</style>
